import { Button, Typography } from '@breetometer/components';
import { copyToClipboard, showToast } from 'BreetHelpers';
import { useModalApi } from 'BreetHooks';
import { type MouseEvent, useCallback } from 'react';

import check from '@/assets/images/gif/check.gif';

import ImageComponent from '../ImageComponent';
import type { IDialogFullScreenNotificationCtaType, IDialogFullScreenNotificationProps } from './helpers';

const DialogFullScreenNotification = () => {
	const { getModalProps, closeModalDirect } = useModalApi();

	const modal = getModalProps('fullScreenNotification')?.metadata as IDialogFullScreenNotificationProps;

	const { header, subheader, cta, ctaType } = modal;

	const ctaTypeObj: Record<IDialogFullScreenNotificationCtaType, () => void> = {
		close: () => closeModalDirect('fullScreenNotification'),
		link: () => console.info('Link'),
	};

	const handleCopyClick = useCallback((event: MouseEvent<HTMLParagraphElement>) => {
		const target = event.target as HTMLElement;
		const copyButton = target.closest('.copy-btn');

		if (!copyButton) return;

		const valueToCopy = copyButton.getAttribute('data-copy-value');

		if (!valueToCopy) {
			showToast('error', 'Failed to copy');
			return;
		}

		copyToClipboard(valueToCopy, 'Wallet address copied')().catch(console.error);
	}, []);

	const ctaHandler = ctaTypeObj[ctaType];
	return (
		<div className='fullScreenNotification'>
			<div className='fullScreenNotification_img'>
				<ImageComponent
					src={check}
					alt='success'
				/>
			</div>
			<Typography as='h2'>{header}</Typography>
			<Typography
				onClick={handleCopyClick}
				dangerouslySetInnerHTML={{ __html: subheader }}
			/>
			<Button
				variant='tertiary'
				onClick={ctaHandler}
				className='tertiary-hover'
			>
				{cta}
			</Button>
		</div>
	);
};

export default DialogFullScreenNotification;
